export default __webpack_public_path__ + "0900839c3fbcafb3c34fa4b727202b53.svg";